// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { MvpApiCreateNewPlanogramGroupData, MvpApiCreateNewPlanogramGroupResponses, MvpApiCreateNewPlanogramsData, MvpApiCreateNewPlanogramsResponses, MvpApiCreateNewProductsData, MvpApiCreateNewProductsResponses, MvpApiCreateNewStorePlanogramData, MvpApiCreateNewStorePlanogramResponses, MvpApiCreateNewSuppliersData, MvpApiCreateNewSuppliersResponses, MvpApiCreateProductIssueData, MvpApiCreateProductIssueResponses, MvpApiCreateStoreSnapshotData, MvpApiCreateStoreSnapshotResponses, MvpApiCwIngestAttachImageData, MvpApiCwIngestAttachImageResponses, MvpApiCwIngestCommitAllData, MvpApiCwIngestCommitAllResponses, MvpApiCwIngestCommitData, MvpApiCwIngestCommitResponses, MvpApiCwIngestLatestData, MvpApiCwIngestLatestItemsData, MvpApiCwIngestLatestItemsResponses, MvpApiCwIngestLatestResponses, MvpApiCwIngestRefreshData, MvpApiCwIngestRefreshResponses, MvpApiCwIngestUnmatchedSuppliersData, MvpApiCwIngestUnmatchedSuppliersResponses, MvpApiFieldAuditData, MvpApiFieldAuditResponses, MvpApiGetPlanogramData, MvpApiGetPlanogramGroupData, MvpApiGetPlanogramGroupResponses, MvpApiGetPlanogramProductData, MvpApiGetPlanogramProductResponses, MvpApiGetPlanogramResponses, MvpApiGetPlanogramSummaryData, MvpApiGetPlanogramSummaryResponses, MvpApiGetProductData, MvpApiGetProductResponses, MvpApiGetRetailerData, MvpApiGetRetailerResponses, MvpApiGetStoreData, MvpApiGetStorePlanogramData, MvpApiGetStorePlanogramResponses, MvpApiGetStoreResponses, MvpApiKrogerIngestBatchData, MvpApiKrogerIngestBatchesData, MvpApiKrogerIngestBatchesResponses, MvpApiKrogerIngestBatchItemsData, MvpApiKrogerIngestBatchItemsResponses, MvpApiKrogerIngestBatchResponses, MvpApiKrogerIngestCommitData, MvpApiKrogerIngestCommitResponses, MvpApiKrogerIngestDeleteBatchData, MvpApiKrogerIngestDeleteBatchResponses, MvpApiKrogerIngestRebuildBatchData, MvpApiKrogerIngestRebuildBatchResponses, MvpApiKrogerIngestUpdateBatchData, MvpApiKrogerIngestUpdateBatchResponses, MvpApiKrogerIngestUploadData, MvpApiKrogerIngestUploadResponses, MvpApiKrogerProductIngestCommitAllData, MvpApiKrogerProductIngestCommitAllResponses, MvpApiKrogerProductIngestCommitData, MvpApiKrogerProductIngestCommitResponses, MvpApiKrogerProductIngestLatestData, MvpApiKrogerProductIngestLatestItemsData, MvpApiKrogerProductIngestLatestItemsResponses, MvpApiKrogerProductIngestLatestResponses, MvpApiKrogerProductIngestRefreshData, MvpApiKrogerProductIngestRefreshResponses, MvpApiListAllPlanogramProductsData, MvpApiListAllPlanogramProductsResponses, MvpApiListPlanogramGroupCountsData, MvpApiListPlanogramGroupCountsResponses, MvpApiListPlanogramGroupsData, MvpApiListPlanogramGroupsResponses, MvpApiListPlanogramGroupsWithMissingProductImageCountData, MvpApiListPlanogramGroupsWithMissingProductImageCountResponses, MvpApiListPlanogramsData, MvpApiListPlanogramsResponses, MvpApiListProductImagesData, MvpApiListProductImagesResponses, MvpApiListProductsData, MvpApiListProductsResponses, MvpApiListRetailersData, MvpApiListRetailersResponses, MvpApiListStorePlanogramsData, MvpApiListStorePlanogramsResponses, MvpApiListStoresData, MvpApiListStoresResponses, MvpApiListSuppliersData, MvpApiListSuppliersResponses, MvpApiListUniquePlanogramDescriptionsData, MvpApiListUniquePlanogramDescriptionsResponses, MvpApiListUniquePlanogramGroupNamesData, MvpApiListUniquePlanogramGroupNamesResponses, MvpApiRegenerateCompositesData, MvpApiRegenerateCompositesResponses, MvpApiSearchProductsData, MvpApiSearchProductsResponses, MvpApiUpdatePlanogramData, MvpApiUpdatePlanogramGroupData, MvpApiUpdatePlanogramGroupResponses, MvpApiUpdatePlanogramResponses, MvpApiUpdateProductData, MvpApiUpdateProductResponses, MvpApiUpdateStorePlanogramData, MvpApiUpdateStorePlanogramResponses, MvpApiUpdateSupplierData, MvpApiUpdateSupplierResponses, MvpApiUploadPlanogramImageData, MvpApiUploadPlanogramImageResponses, MvpApiUploadProductImageData, MvpApiUploadProductImageResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List Products
 */
export const mvpApiListProducts = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListProductsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products',
    ...options
});

/**
 * Create New Products
 */
export const mvpApiCreateNewProducts = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewProductsData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateNewProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Field Audit
 */
export const mvpApiFieldAudit = <ThrowOnError extends boolean = false>(options: Options<MvpApiFieldAuditData, ThrowOnError>) => (options.client ?? client).get<MvpApiFieldAuditResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/field-audit',
    ...options
});

/**
 * Get Product
 */
export const mvpApiGetProduct = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetProductData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetProductResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/{product_id}',
    ...options
});

/**
 * Update Product
 */
export const mvpApiUpdateProduct = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateProductData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateProductResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Products
 */
export const mvpApiSearchProducts = <ThrowOnError extends boolean = false>(options?: Options<MvpApiSearchProductsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiSearchProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/search',
    ...options
});

/**
 * Upload Product Image
 */
export const mvpApiUploadProductImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiUploadProductImageData, ThrowOnError>) => (options.client ?? client).post<MvpApiUploadProductImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/upload-image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Cw Ingest Refresh
 *
 * Kick off a background build of the newest Chemist Warehouse product feed.
 *
 * Creates a pending CWH ProductIngestBatch and dispatches a Taskhawk task to pull the
 * latest Product_Metadata drop, filter and reconcile it, and persist the
 * proposal. Returns immediately; poll GET /products/cw-ingest/latest for status.
 */
export const mvpApiCwIngestRefresh = <ThrowOnError extends boolean = false>(options?: Options<MvpApiCwIngestRefreshData, ThrowOnError>) => (options?.client ?? client).post<MvpApiCwIngestRefreshResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/refresh',
    ...options
});

/**
 * Cw Ingest Latest
 *
 * The most recent ingest batch (status + summary counts), or null if none.
 */
export const mvpApiCwIngestLatest = <ThrowOnError extends boolean = false>(options?: Options<MvpApiCwIngestLatestData, ThrowOnError>) => (options?.client ?? client).get<MvpApiCwIngestLatestResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/latest',
    ...options
});

/**
 * Cw Ingest Latest Items
 *
 * Paged rows of the latest batch — filter by kind/action/has_upc/has_lockie_plu/
 * supplier_matched.
 */
export const mvpApiCwIngestLatestItems = <ThrowOnError extends boolean = false>(options?: Options<MvpApiCwIngestLatestItemsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiCwIngestLatestItemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/latest/items',
    ...options
});

/**
 * Cw Ingest Commit
 *
 * Apply the reviewed items to Products: creates and updates, resolving each
 * supplier by explicit choice or manufacturer match (never auto-creating one).
 * Each item commits independently; the response reports per-item results.
 */
export const mvpApiCwIngestCommit = <ThrowOnError extends boolean = false>(options: Options<MvpApiCwIngestCommitData, ThrowOnError>) => (options.client ?? client).post<MvpApiCwIngestCommitResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cw Ingest Commit All
 *
 * Commit every uncommitted row matching a filter, in the background.
 *
 * The per-item endpoint can't carry a whole-feed sweep: adding a metadata key
 * turns nearly every existing CWH product into a changed update (~50k rows),
 * which is a thousand pages of 50-row selection. This takes the reviewer's
 * current filter instead, then a self-chunking Taskhawk task works through it.
 * Returns immediately with the matched count; poll GET /products/cw-ingest/latest
 * for commit_status / commit_progress.
 */
export const mvpApiCwIngestCommitAll = <ThrowOnError extends boolean = false>(options: Options<MvpApiCwIngestCommitAllData, ThrowOnError>) => (options.client ?? client).post<MvpApiCwIngestCommitAllResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/commit-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cw Ingest Attach Image
 *
 * Resolve a just-created product's CW image by chem_id and store it, server-side
 * because the CW CDN blocks cross-origin browser fetches. The frontend calls this
 * once per created product to drive its attach-progress display.
 *
 * All the CW-specific work lives in mvp.cw_image so this stopgap can be removed as
 * a unit. Returns 'attached', 'no_image' (not in the index / no image), or 'error'.
 */
export const mvpApiCwIngestAttachImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiCwIngestAttachImageData, ThrowOnError>) => (options.client ?? client).post<MvpApiCwIngestAttachImageResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/attach-image',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cw Ingest Unmatched Suppliers
 *
 * Distinct feed manufacturers in the latest batch that don't match an existing
 * supplier (uncommitted candidates), with how many products each affects — the
 * worklist for the Supplier Resolution step.
 */
export const mvpApiCwIngestUnmatchedSuppliers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiCwIngestUnmatchedSuppliersData, ThrowOnError>) => (options?.client ?? client).get<MvpApiCwIngestUnmatchedSuppliersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/cw-ingest/latest/unmatched-suppliers',
    ...options
});

/**
 * Kroger Product Ingest Refresh
 *
 * Kick off a background build of the Kroger pilot-store catalog.
 *
 * Returns the pending batch immediately; the build runs as a chain of tasks
 * (~10 min for ~38k rows). Poll GET /products/kroger-ingest/latest for status
 * and build_progress.
 */
export const mvpApiKrogerProductIngestRefresh = <ThrowOnError extends boolean = false>(options?: Options<MvpApiKrogerProductIngestRefreshData, ThrowOnError>) => (options?.client ?? client).post<MvpApiKrogerProductIngestRefreshResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/kroger-ingest/refresh',
    ...options
});

/**
 * Kroger Product Ingest Latest
 *
 * The most recent Kroger catalog batch (status, progress, summary), or null.
 */
export const mvpApiKrogerProductIngestLatest = <ThrowOnError extends boolean = false>(options?: Options<MvpApiKrogerProductIngestLatestData, ThrowOnError>) => (options?.client ?? client).get<MvpApiKrogerProductIngestLatestResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/kroger-ingest/latest',
    ...options
});

/**
 * Kroger Product Ingest Latest Items
 *
 * Paged rows of the latest Kroger batch — filter by kind/action/image_action/
 * changed/committed; search description, UPC, brand.
 */
export const mvpApiKrogerProductIngestLatestItems = <ThrowOnError extends boolean = false>(options?: Options<MvpApiKrogerProductIngestLatestItemsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiKrogerProductIngestLatestItemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/kroger-ingest/latest/items',
    ...options
});

/**
 * Kroger Product Ingest Commit
 *
 * Apply the selected rows: create/update the products, then attach any
 * packshot to add or replace. Each row commits independently.
 */
export const mvpApiKrogerProductIngestCommit = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerProductIngestCommitData, ThrowOnError>) => (options.client ?? client).post<MvpApiKrogerProductIngestCommitResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/kroger-ingest/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Kroger Product Ingest Commit All
 *
 * Commit every uncommitted row matching a filter, in the background. Poll
 * GET /products/kroger-ingest/latest for commit_status / commit_progress.
 */
export const mvpApiKrogerProductIngestCommitAll = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerProductIngestCommitAllData, ThrowOnError>) => (options.client ?? client).post<MvpApiKrogerProductIngestCommitAllResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/products/kroger-ingest/commit-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Kroger Ingest Upload
 *
 * Ingest one or more Kroger planogram files, end to end.
 *
 * Accepts the original .psa or the intermediate .json that kroger-json.py
 * emits. One batch per file — a file is one fixture, and each is parsed,
 * validated and committed on its own. The raw bytes are kept in GCS so a batch
 * can be re-parsed later without a re-upload.
 *
 * Returns immediately, before any parsing. The rest runs in the background and
 * the batch is the only thing to poll: `status` walks pending -> parsing ->
 * ready, then `commit_status` walks idle -> running -> done, with
 * commit_progress carrying the counts and committed_planogram_id the result.
 * Anything that fails validation leaves the batch uncommitted with the reasons
 * in commit_error; nothing partial is ever written. Set KROGER_AUTO_COMMIT to
 * false to stop at `ready` and drive the commit endpoint by hand instead.
 *
 * Local and staging runs have no taskhawk consumer to pick the job up. The
 * ingest_kroger_planograms management command runs the same work in-process
 * there — against a local file, or against a batch this endpoint has staged.
 */
export const mvpApiKrogerIngestUpload = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestUploadData, ThrowOnError>) => (options.client ?? client).post<MvpApiKrogerIngestUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Kroger Ingest Batches
 *
 * Staged Kroger ingests, newest first. Unlike CWH's single rolling batch,
 * one accumulates per uploaded .psa.
 */
export const mvpApiKrogerIngestBatches = <ThrowOnError extends boolean = false>(options?: Options<MvpApiKrogerIngestBatchesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiKrogerIngestBatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches',
    ...options
});

/**
 * Kroger Ingest Delete Batch
 *
 * Discard an uncommitted batch. Committed batches are kept as the record of
 * where a planogram came from.
 */
export const mvpApiKrogerIngestDeleteBatch = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestDeleteBatchData, ThrowOnError>) => (options.client ?? client).delete<MvpApiKrogerIngestDeleteBatchResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches/{batch_id}',
    ...options
});

/**
 * Kroger Ingest Batch
 *
 * One batch: status, summary counts, bay geometry, and unmatched suppliers.
 */
export const mvpApiKrogerIngestBatch = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestBatchData, ThrowOnError>) => (options.client ?? client).get<MvpApiKrogerIngestBatchResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches/{batch_id}',
    ...options
});

/**
 * Kroger Ingest Update Batch
 *
 * Set the planogram group, name, or type before committing. The .psa names
 * the fixture but not which planogram group it belongs to.
 */
export const mvpApiKrogerIngestUpdateBatch = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestUpdateBatchData, ThrowOnError>) => (options.client ?? client).patch<MvpApiKrogerIngestUpdateBatchResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches/{batch_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Kroger Ingest Batch Items
 *
 * Paged product rows of a batch — filter by action/has_upc/supplier_matched/
 * committed/changed.
 */
export const mvpApiKrogerIngestBatchItems = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestBatchItemsData, ThrowOnError>) => (options.client ?? client).get<MvpApiKrogerIngestBatchItemsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches/{batch_id}/items',
    ...options
});

/**
 * Kroger Ingest Rebuild Batch
 *
 * Re-parse and re-enrich a batch from its stored .psa.
 *
 * For a batch that failed, or whose enrichment came back empty because the
 * Kroger API was down. Replaces the staged rows; refuses once committed.
 */
export const mvpApiKrogerIngestRebuildBatch = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestRebuildBatchData, ThrowOnError>) => (options.client ?? client).post<MvpApiKrogerIngestRebuildBatchResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches/{batch_id}/rebuild',
    ...options
});

/**
 * Kroger Ingest Commit
 *
 * Commit a reviewed batch: write its Products and Suppliers, create the
 * Planogram and its PlanogramProducts, then attach product images.
 *
 * The write is one transaction in a background task — a fixture is committed
 * whole or not at all. Returns immediately with what it will write; poll the
 * batch for commit_status / commit_progress.
 */
export const mvpApiKrogerIngestCommit = <ThrowOnError extends boolean = false>(options: Options<MvpApiKrogerIngestCommitData, ThrowOnError>) => (options.client ?? client).post<MvpApiKrogerIngestCommitResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/kroger-ingest/batches/{batch_id}/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Planograms
 */
export const mvpApiListPlanograms = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListPlanogramsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms',
    ...options
});

/**
 * Create New Planograms
 */
export const mvpApiCreateNewPlanograms = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewPlanogramsData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateNewPlanogramsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Unique Planogram Descriptions
 */
export const mvpApiListUniquePlanogramDescriptions = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListUniquePlanogramDescriptionsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListUniquePlanogramDescriptionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/unique-planogram-descriptions',
    ...options
});

/**
 * Get Planogram
 */
export const mvpApiGetPlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/{planogram_id}',
    ...options
});

/**
 * Update Planogram
 */
export const mvpApiUpdatePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdatePlanogramData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdatePlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/{planogram_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Planogram Summary
 */
export const mvpApiGetPlanogramSummary = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramSummaryData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramSummaryResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/{planogram_id}/summary',
    ...options
});

/**
 * Get Planogram Product
 */
export const mvpApiGetPlanogramProduct = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramProductData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramProductResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/{planogram_id}/products/{planogram_product_id}',
    ...options
});

/**
 * List All Planogram Products
 *
 * Flat, paginated PlanogramProduct list. Filter by id(s), planogram, product,
 * or an updated_after/updated_before time window.
 */
export const mvpApiListAllPlanogramProducts = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListAllPlanogramProductsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListAllPlanogramProductsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-products',
    ...options
});

/**
 * Upload Planogram Image
 */
export const mvpApiUploadPlanogramImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiUploadPlanogramImageData, ThrowOnError>) => (options.client ?? client).post<MvpApiUploadPlanogramImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/upload-image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Regenerate Composites
 *
 * Completion trigger for background composites (ATL-19).
 *
 * A caller that just finished uploading a batch of product images (bulk
 * "Missing Product Images", the .psa bitmap flow, or a one-off upload) calls
 * this once to re-render the affected planograms — instead of the per-image
 * endpoint firing hundreds of redundant renders. Resolves product_ids to the
 * planograms that place them, unions with planogram_ids, dedups, and dispatches
 * one composite task per planogram. min_image_fraction=0.0: the upload just
 * finished, so render whatever is present rather than gating on readiness.
 */
export const mvpApiRegenerateComposites = <ThrowOnError extends boolean = false>(options: Options<MvpApiRegenerateCompositesData, ThrowOnError>) => (options.client ?? client).post<MvpApiRegenerateCompositesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planograms/regenerate-composites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Store Planograms
 */
export const mvpApiListStorePlanograms = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStorePlanogramsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListStorePlanogramsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/store-planograms',
    ...options
});

/**
 * Create New Store Planogram
 */
export const mvpApiCreateNewStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewStorePlanogramData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateNewStorePlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/store-planograms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Store Planogram
 */
export const mvpApiGetStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetStorePlanogramData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetStorePlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/store-planograms/{store_planogram_id}',
    ...options
});

/**
 * Update Store Planogram
 */
export const mvpApiUpdateStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateStorePlanogramData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateStorePlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/store-planograms/{store_planogram_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Suppliers
 */
export const mvpApiListSuppliers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListSuppliersData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListSuppliersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/suppliers',
    ...options
});

/**
 * Create New Suppliers
 */
export const mvpApiCreateNewSuppliers = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewSuppliersData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateNewSuppliersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/suppliers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Supplier
 */
export const mvpApiUpdateSupplier = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateSupplierData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateSupplierResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/suppliers/{supplier_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Retailers
 */
export const mvpApiListRetailers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListRetailersData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListRetailersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/retailers',
    ...options
});

/**
 * Get Retailer
 */
export const mvpApiGetRetailer = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetRetailerData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetRetailerResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/retailers/{retailer_id}',
    ...options
});

/**
 * List Stores
 */
export const mvpApiListStores = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStoresData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListStoresResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/stores',
    ...options
});

/**
 * Get Store
 */
export const mvpApiGetStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetStoreData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetStoreResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/{store_id}',
    ...options
});

/**
 * Create Store Snapshot
 */
export const mvpApiCreateStoreSnapshot = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateStoreSnapshotData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateStoreSnapshotResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/stores/{store_id}/snapshot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Planogram Groups
 */
export const mvpApiListPlanogramGroups = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramGroupsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListPlanogramGroupsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-groups',
    ...options
});

/**
 * Create New Planogram Group
 */
export const mvpApiCreateNewPlanogramGroup = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewPlanogramGroupData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateNewPlanogramGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Planogram Groups With Missing Product Image Count
 *
 * Get all planogram groups with their missing image counts in a single query.
 * Returns a list of dictionaries with id, name, missing_product_image_count, and total_product_count.
 *
 * [
 * { "id": "...", "name": "SKINCARE, DRY", "missing_product_image_count": 26, "total_product_count": 455 },
 * { "id": "...", "name": "HAIRCARE, COLOURS", "missing_product_image_count": 24, "total_product_count": 418 },
 * ...
 * ]
 */
export const mvpApiListPlanogramGroupsWithMissingProductImageCount = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramGroupsWithMissingProductImageCountData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListPlanogramGroupsWithMissingProductImageCountResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-groups-with-missing-product-image-count',
    ...options
});

/**
 * List Planogram Group Counts
 *
 * Per planogram group: the unique-variant count and the distinct product count,
 * computed over only the latest planogram per (group, description).
 *
 * "Latest per description" matches what the Asset Admin Groups table already
 * shows for UNIQUE VARIANTS — superseded re-ingests of the same variant are
 * collapsed to their newest version. Summing per-variant product counts would
 * overcount heavily (products repeat across variants), so the distinct count is
 * taken across all latest variants at once.
 *
 * Deliberately its own endpoint, not a field on `/planogram-groups`: that list
 * has many callers that only need id -> name and shouldn't pay for this
 * aggregation over mvp_planogramproduct. Read-only, no migration.
 *
 * GET /v0/planogram-group-counts?retailer_id=<uuid|omitted>
 * -> [{ "id": "...", "name": "HAIRCARE, STYLING", "variant_count": 6, "product_count": 203 }]
 *
 * Groups with no planograms are omitted (nothing to count), matching the Groups
 * table, which hides zero-variant groups.
 */
export const mvpApiListPlanogramGroupCounts = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramGroupCountsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListPlanogramGroupCountsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-group-counts',
    ...options
});

/**
 * List Unique Planogram Group Names
 */
export const mvpApiListUniquePlanogramGroupNames = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListUniquePlanogramGroupNamesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListUniquePlanogramGroupNamesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/unique-planogram-groups-names',
    ...options
});

/**
 * Get Planogram Group
 */
export const mvpApiGetPlanogramGroup = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramGroupData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-groups/{planogram_group_id}',
    ...options
});

/**
 * Update Planogram Group
 */
export const mvpApiUpdatePlanogramGroup = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdatePlanogramGroupData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdatePlanogramGroupResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/planogram-groups/{planogram_group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Product Images
 */
export const mvpApiListProductImages = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListProductImagesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListProductImagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/product-images',
    ...options
});

/**
 * Create Product Issue
 */
export const mvpApiCreateProductIssue = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateProductIssueData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateProductIssueResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v0/product-issues',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
